import { useState } from 'react';
import api from '../../api';
import CustomerForm from './CustomerForm';

export default function CustomerList({ customers, loading, selected, onSelect, onCreated }) {
  const [search, setSearch] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [localCustomers, setLocalCustomers] = useState(null);
  const [searching, setSearching] = useState(false);

  async function handleSearch(q) {
    setSearch(q);
    if (!q) { setLocalCustomers(null); return; }
    setSearching(true);
    const res = await api.get(`/customers/?q=${encodeURIComponent(q)}`).catch(() => ({ data: [] }));
    setLocalCustomers(res.data);
    setSearching(false);
  }

  function handleCreated(customer) {
    onCreated(customer);
    setShowForm(false);
  }

  const list = localCustomers !== null ? localCustomers : customers;

  return (
    <div className="crm-sidebar">
      <div style={styles.top}>
        <input style={styles.searchInput}
          placeholder="🔍 Телефон або ім'я..."
          value={search}
          onChange={e => handleSearch(e.target.value)} />
        <button style={styles.addBtn} onClick={() => setShowForm(true)} title="Додати клієнта">+</button>
      </div>

      {showForm && <CustomerForm onCreated={handleCreated} onClose={() => setShowForm(false)} />}

      <div style={styles.list}>
        {loading || searching ? <p style={styles.hint}>Завантаження...</p> :
        list.length === 0 ? <p style={styles.hint}>Клієнтів не знайдено</p> :
        list.map(c => (
          <div key={c.id}
            style={{...styles.item, ...(selected?.id === c.id ? styles.itemActive : {})}}
            onClick={() => onSelect(c)}>
            <div style={styles.avatar}>
              {c.full_name?.[0]?.toUpperCase() || c.phone[0]}
            </div>
            <div style={{flex:1, minWidth:0}}>
              <div style={styles.name}>
                {c.full_name || 'Без імені'}
                {c.is_blacklisted && ' 🚫'}
                {c.age_verified && ' ✅'}
              </div>
              <div style={styles.phone}>{c.phone}</div>
              {c.store_ids?.length > 0 && (
                <div style={styles.stores}>🏪 {c.store_ids.map(s => s.name).join(', ')}</div>
              )}
            </div>
            <div style={styles.bonus}>🎁 {parseFloat(c.bonus_balance).toFixed(0)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  top: { display:'flex', gap:'6px', margin:'12px' },
  searchInput: { flex:1, padding:'9px 12px', borderRadius:'8px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'13px' },
  addBtn: { width:'36px', height:'36px', background:'#f5a623', color:'#14110c', border:'none', borderRadius:'8px', fontWeight:'bold', cursor:'pointer', fontSize:'20px', flexShrink:0 },
  list: { flex:1, overflowY:'auto' },
  item: { display:'flex', alignItems:'flex-start', gap:'10px', padding:'10px 14px', cursor:'pointer', borderBottom:'1px solid #38301f' },
  itemActive: { background:'#1c1812' },
  avatar: { width:'34px', height:'34px', borderRadius:'50%', background:'#38301f', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'14px', fontWeight:'bold', color:'#f5a623', flexShrink:0, marginTop:'2px' },
  name: { fontSize:'13px', fontWeight:'bold', marginBottom:'2px' },
  phone: { color:'#9a8a6e', fontSize:'12px' },
  stores: { color:'#9a8a6e', fontSize:'11px', marginTop:'2px' },
  bonus: { fontSize:'11px', color:'#f5a623', background:'#38301f', padding:'2px 7px', borderRadius:'10px', whiteSpace:'nowrap', marginTop:'2px' },
  hint: { color:'#9a8a6e', textAlign:'center', padding:'16px' },
};
